'use client';

import React from 'react';
import sparkline from '../../lib/sparkline';

export interface SparklineProps {
  className?: string;
  data: number[];
  height: number;
  width?: number;
  color?: React.CSSProperties['color'];
}

export class Sparkline extends React.PureComponent<SparklineProps> {
  static defaultProps = {
    color: '#3490dc',
  };
  private canvas?: HTMLCanvasElement;

  componentDidMount() {
    const { color, data } = this.props;
    sparkline(this.canvas as HTMLCanvasElement, data, false, color);
  }

  componentDidUpdate() {
    const { color, data } = this.props;
    sparkline(this.canvas as HTMLCanvasElement, data, false, color);
  }

  render() {
    const { data, height, width, ...props } = this.props;

    return (
      <canvas
        height={height}
        ref={(element: HTMLCanvasElement) => {
          this.canvas = element;
        }}
        width={width}
        {...props}
      />
    );
  }
}
